import Axios from 'axios';
import client from '@/lib/http-client';
import { buildQuery } from '@/lib/helper';
// import client from '@/lib/http-client-cron';

const endpoint = '/admin';
const reconcileApiUrl = process.env.VUE_APP_API_RECONCILE_URL;

export default {
	/**
	 * Shipping Reconcile
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	shippingReconcile(params, cb, errorCb) {
		const url = `${reconcileApiUrl}${endpoint}/shipping_reconciliation`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Shipping Invoice Reconcile
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	shippingInvoiceReconcile(params, cb, errorCb, customClient) {
		const url = `${endpoint}/shipping_invoice_reconciliation`;
		const axiosClient = customClient || client;
		axiosClient
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Search Shipments
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	searchShipments(params, cb, errorCb) {
		const url = `${endpoint}/shipping_details`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Search Orders
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	searchOrders(params, cb, errorCb) {
		const url = `${endpoint}/submission`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Search User
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	searchUser(params, cb, errorCb) {
		const url = `${endpoint}/search_user`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Order Statistic
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	orderStatistic(params, cb, errorCb) {
		const url = `${endpoint}/submission/statistic`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Update Submission Status
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	setStatus(submissionId, params, cb, errorCb) {
		const url = `${endpoint}/submission/${submissionId}/status`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Cancel Shipments
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	cancelShipments(params, cb, errorCb) {
		const url = `${endpoint}/cancel_shipment`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Logistics
	 * @param {*} params
	 * @param {*} cb
	 * @param {*} errorCb
	 */
	getLogistics(params, cb, errorCb, cancelToken) {
		const url = `${endpoint}/logistics`;
		client
			.get(url, { params, cancelToken })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (!Axios.isCancel(e)) {
					if (errorCb) errorCb(e);
				}
			});
	},

	/**
	 * Create Logistic
	 * @param {*} params
	 * @param {*} cb
	 * @param {*} errorCb
	 */
	createLogistic(params, cb, errorCb) {
		const url = `${endpoint}/logistics`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	createLogisticBulk(params, cb, errorCb) {
		const url = `${endpoint}/logistics/bulk`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Update Contact
	 *
	 * @param {string} id Contact ID
	 * @param {Object} params
	 * @param {Object} params.customer_data Customer Data
	 * @param {string} params.customer_data.name Customer Data Name
	 * @param {string} params.customer_data.email Customer Data Email
	 * @param {string} params.customer_data.picture Customer Data Picture
	 * @param {string[]} params.customer_data.tags Customer Data Tag
	 * @param {string} params.customer_data.label Customer Address Label
	 * @param {string} params.customer_data.receiver_name Customer Address Receiver Name
	 * @param {string} params.customer_data.province_id Customer Address Province ID
	 * @param {string} params.customer_data.province_name Customer Address Province Name
	 * @param {string} params.customer_data.city_id Customer Address City ID
	 * @param {string} params.customer_data.city_name Customer Address City Name
	 * @param {string} params.customer_data.city_name_with_type Customer Address City Name With Type
	 * @param {string} params.customer_data.subdistrict_id Customer Address Subdistrict ID
	 * @param {string} params.customer_data.subdistrict_name Customer Address Subdistrict Name
	 * @param {string} params.customer_data.address Customer Address
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	updateLogistic(id, params, cb, errorCb) {
		const url = `${endpoint}/logistics/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Logistic Stats
	getLogisticStats(params, cb, errorCb, cancelToken) {
		const url = `${endpoint}/logistics/stats`;
		client
			.get(url, { params, cancelToken })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (!Axios.isCancel(e)) {
					if (errorCb) errorCb(e);
				}
			});
	},

	// Get Order ID by Receipt Number
	getOrderId(params, cb, errorCb) {
		const url = `${endpoint}/order_id_by_receipt`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Receipt Number by Order ID
	getReceiptNumbers(params, cb, errorCb) {
		const url = `${endpoint}/receipt_number_by_order_id`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Refund E-Payment Shipping Cost
	refundShippingCost(orderId, cb, errorCb) {
		const url = `${endpoint}/shipping_cost_refund`;
		const params = { order_id: orderId };
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Change Shipment Status
	changeShipmentStatus(params, cb, errorCb) {
		const url = `${endpoint}/shipment_status`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Change Shipment Status by Receipt Numbers
	changeShipmentStatusByReceipts(receiptNumbers, status, cb, errorCb) {
		const url = `${endpoint}/shipment_status_by_receipts`;
		const receiptNumbersString = JSON.stringify(receiptNumbers);
		const params = {
			receipt_numbers: receiptNumbersString,
			status,
		};
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Change Receipt Number
	changeReceiptNumber(params, cb, errorCb) {
		const url = `${endpoint}/shipment_receipt_number`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Cancel Billing & Wallet
	cancelBillingWallet(ids, cb, errorCb) {
		const params = {
			order_ids: JSON.stringify(ids),
		};
		const url = `${endpoint}/cancel_billing`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Restore Orders by Order Ids
	restoreOrders(ids, cb, errorCb) {
		const params = {
			ids: JSON.stringify(ids),
		};
		const url = `${endpoint}/restore_orders`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Add Feature to user
	addFeature(params, cb, errorCb) {
		const url = `${endpoint}/features`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Remove Feature from user
	removeFeature(params, cb, errorCb) {
		const url = `${endpoint}/features`;
		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Search Shipments by receipt number
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	searchByReceipt(params, cb, errorCb) {
		const url = `${endpoint}/logistics/search`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// products
	getProducts(params, cb, errorCb) {
		const url = `${endpoint}/products`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// export products
	exportProducts(params, cb, errorCb) {
		const url = `${endpoint}/products/export`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Restore product by id
	restoreProduct(id, cb, errorCb) {
		const url = `${endpoint}/products/${id}/restore`;
		client
			.post(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// History product by id
	getProductHistoryLog(id, cb, errorCb) {
		const url = `${endpoint}/products/${id}/product_history`;
		client
			.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/**
	 * Export logistic monitoring
	 *
	 * @param {Object} params
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	exportLogistics(params, cb, errorCb) {
		const url = `${endpoint}/logistics/export`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Export monitoring orders
	 *
	 * @param {Object} params
	 * @param {'boolean'} params.is_manifested manifested filter
	 * @param {'string'} params.keyword Search Keyword
	 * @param {'integer'} params.limit Limit Data
	 * @param {'integer'} params.page Page Number
	 * @param {'string'} params.since Date Since
	 * @param {'string'} params.sort Sort
	 * @param {'string'} params.sort_by Sort By
	 * @param {'string'} params.status Status Manifest
	 * @param {'string'} params.type Export Type
	 * @param {'string'} params.until Date Until
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	exportMonitoringOrders(params, cb, errorCb) {
		const url = `${endpoint}/submission/export`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export Users
	exportUsers(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/user/export?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export Suppliers
	exportSuppliers(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/supplier/export?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export Supplier Report
	exportSupplierReport(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/supplier/export-report?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Order Details by Order ID
	 *
	 * @param {string} id order id
	 * @param {Object} params
	 * @param {boolean} [params.with_user] With User
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getOrderDetails(id, params, cb, errorCb) {
		const url = `${endpoint}/orders/${id}`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Order Details by Order ID
	 *
	 * @param {string} id order id
	 * @param {Object} params
	 * @param {boolean} [params.with_user] With User
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getDisbursedCod(params, cb, errorCb) {
		const url = `${endpoint}/get_disbursed_cod`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Change status product by Product Id
	updateStatusProduct(id, params, cb, errorCb) {
		const url = `${endpoint}/products/${id}/status`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Bulk Delete product by Product Ids
	bulkDeleteProduct(ids = [], cb, errorCb) {
		const url = `${endpoint}/products`;

		const idsJSON = JSON.stringify(ids);
		const params = {
			product_ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	// Bulk Update Status Product by Product Ids
	bulkUpdateStatusProduct(ids = [], statusProduct, isVerified, cb, errorCb) {
		const url = `${endpoint}/products/update_status_bulk`;
		const verified = isVerified;
		const idsJSON = JSON.stringify(ids);
		const params = {
			product_ids: idsJSON,
			status: statusProduct,
			is_verified: verified,
		};

		client
			.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	// Bulk Restore product by Product Ids
	bulkRestoreProduct(ids = [], cb, errorCb) {
		const url = `${endpoint}/products/restore`;

		const idsJSON = JSON.stringify(ids);
		const params = {
			product_ids: idsJSON,
		};

		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	updateProduct(id, params, cb, errorCb) {
		const url = `${endpoint}/products/${id}/update`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// brands
	getBrands(params, cb, errorCb) {
		const url = `${endpoint}/brand`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update brand by Brand Id
	updateBrand(id, params, cb, errorCb) {
		const url = `${endpoint}/brand/${id}/update`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// directs
	getDirects(params, cb, errorCb) {
		const url = `${endpoint}/direct`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update direct by Direct Id
	updateDirect(id, params, cb, errorCb) {
		const url = `${endpoint}/direct/${id}/update`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update List Supplier Banner
	listSupplierBanner(params, cb, errorCb) {
		const query = buildQuery(params);
		// const url = `https://1e219ed4-42f4-45b1-a685-6eee6c3289b1.mock.pstmn.io/admin/supplier_banner?${query}`;
		const url = `${endpoint}/supplier_banner?${query}`;
		client
			.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Admin - Create Banner Supplier
	createBanner(params, cb, errorCb) {
		const url = `${endpoint}/supplier_banner`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin - Create Banner Supplier
	deleteBanner(id, cb, errorCb) {
		const url = `${endpoint}/supplier_banner/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin - Change Banner Position
	changeOrderBanner(params, cb, errorCb) {
		const url = `${endpoint}/supplier_banner/order`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin - Get Export Page List
	getListExportPage(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export/list?${query}`;
		client
			.get(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Get List of Sales
	getSales(params, cb, errorCb) {
		const url = `${endpoint}/sales`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Create Sales
	createSales(params, cb, errorCb) {
		const url = `${endpoint}/sales`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin - Export Queue
	exportSubmissionQueue(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/submission/export_queue?${query}`;
		client
			.get(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Delete Sales
	deleteSales(params, cb, errorCb) {
		const url = `${endpoint}/sales`;
		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Create Sales
	assignSales(params, cb, errorCb) {
		const url = `${endpoint}/sales/assign`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get List of Assigned Seller
	getAssignedSeller(params, cb, errorCb) {
		const url = `${endpoint}/sales/get_assigned_seller`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Bulk Assign Seller to Sales
	bulkAssign(params, cb, errorCb) {
		const url = `${endpoint}/sales/bulk_assign`;
		client
			.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get Sales Detail
	getSalesDetail(id, params, cb, errorCb) {
		const url = `${endpoint}/sales/detail/${id}`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get List of Sales Order Monitoring
	getSalesMonitoring(params, cb, errorCb) {
		const url = `${endpoint}/monitoring-sales`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Sales Monitoring Detail
	getSalesMonitoringDetail(id, params, cb, errorCb) {
		const url = `${endpoint}/monitoring-sales/detail/${id}`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export Sales Monitoring
	exportSalesMonitoring(params, cb, errorCb) {
		const url = `${endpoint}/monitoring-sales/export`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// List Admin Ticket
	listTicket(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/ticket?${query}`;
		client
			.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Update admin ticket
	updateTicket(params, cb, errorCb) {
		const url = `${endpoint}/ticket/${params.selected_id}/update_status`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin - Change Banner Position
	saveMessageTicket(params, cb, errorCb) {
		const url = `${endpoint}/ticket/save_message`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// List Ticket Message
	listTicketMessage(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/ticket/message?${query}`;
		client
			.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// List Admin Ask Stock
	listAskStock(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/ask-stock?${query}`;
		client
			.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Admin - Ask Stock - Update Status
	updateStatusAskStock(params, cb, errorCb) {
		const url = `${endpoint}/ask-stock/status`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin - Ask Stock - Save Message
	saveMessageAskStock(params, cb, errorCb) {
		const url = `${endpoint}/ask-stock/message`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// List Ask Stock Message
	listAskStockMessage(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/ask-stock/message?${query}`;
		client
			.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// List Seller on Product
	listSellerOnProduct(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/products/list-seller?${query}`;
		client
			.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/**
	 * Get List Leads Orders
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	getLeadsOrder(params, cb, errorCb) {
		const url = `${endpoint}/leads-order`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Leads Order Statistic
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	statisticLeadsOrder(params, cb, errorCb) {
		const url = `${endpoint}/leads-order/statistic`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Export Leads Order
	 * @param {Object} params Request Params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	exportLeadsOrder(params, cb, errorCb) {
		const url = `${endpoint}/leads-order/export`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Seller Connection List
	sellerConnectionList(userId, cb, errorCb) {
		const url = `${endpoint}/user/connection/${userId}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Seller Reconnect Account Connection
	sellerConnectionReconnect(id, params, cb, errorCb) {
		const url = `${endpoint}/user/connection/${id}/reconnect`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};

// Get List of Product Timeline
export const getProductTimeline = (id, params, cb, errorCb) => {
	const url = `${endpoint}/products/${id}/product_timeline`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Export List of Product Timeline
export const exportProductTimeline = (id, params, cb, errorCb) => {
	const url = `${endpoint}/products/${id}/export_product_timeline`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Get List of Product Requests
export const getProductRequests = (params, cb, errorCb) => {
	const url = `${endpoint}/product-request`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Update Product Request Status by ID
export const updateProductRequestStatus = (id, params, cb, errorCb) => {
	const url = `${endpoint}/product-request/${id}/status`;
	client
		.put(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Get List of Fraud Users
export const getFraudUsers = (params, cb, errorCb) => {
	const query = buildQuery(params);
	const url = `${endpoint}/fraud-monitoring?${query}`;
	client
		.get(url)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

// Export List of Fraud Users
export const exportFraud = (params, cb, errorCb) => {
	const query = buildQuery(params);
	const url = `${endpoint}/fraud-monitoring/export?${query}`;
	client
		.get(url)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

// Update Fraud User
export const updateFraudUser = (id, params, cb, errorCb) => {
	const url = `${endpoint}/fraud-monitoring/${id}/status`;
	client
		.put(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Bulk Update Blacklisted Sellers
export const bulkUpdateBlacklistedSellers = (params, cb, errorCb) => {
	const url = `${endpoint}/products/bulk-blacklisted-sellers`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Bulk Update Handling Fee for Products
export const bulkUpdateHandlingFee = (productIds, handlingFeeConfig, cb, errorCb) => {
	const url = `${endpoint}/products/bulk-handling-fee`;
	const params = {
		product_ids: productIds,
		type: handlingFeeConfig.type,
		fee_supplier: handlingFeeConfig.fee_supplier,
		margin_platform: handlingFeeConfig.margin_platform,
		value: handlingFeeConfig.value,
		fee_config: {
			type: handlingFeeConfig.type,
			fee_supplier: handlingFeeConfig.fee_supplier,
			margin_platform: handlingFeeConfig.margin_platform,
			value: handlingFeeConfig.value,
		},
	};
	client
		.post(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e || new Error('Unknown error occurred'));
		});
};

export const bulkUpdateCommission = (payload, cb, errorCb) => {
	const url = `${endpoint}/products/bulk-update-commission`;
	const params = {
		product_ids: payload.product_ids,
		commission_config: payload.commission_config,
	};
	client
		.post(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Get List of Change Source Histories
export const getChangeSourceHistories = (params, cb, errorCb) => {
	const url = `${endpoint}/change-sources`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Create Change Source History
export const createChangeSourceHistory = (params, cb, errorCb) => {
	const url = `${endpoint}/change-sources`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Export Change Source Histories
export const exportChangeSourceHistories = (params, cb, errorCb) => {
	const url = `${endpoint}/change-sources/export`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Get User Detail
export const getUserDetail = (id, params, cb, errorCb) => {
	const url = `${endpoint}/user/detail/${id}`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Bulk Update Store Status
export const bulkUpdateStoreStatus = (params, cb, errorCb) => {
	const url = `${endpoint}/user/update_store_status`;
	client
		.put(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

export const getDataOtp = (params, cb, errorCb) => {
	const url = `${endpoint}/otp`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

export const createWholesaleBanner = (params, cb, errorCb) => {
	const url = `${endpoint}/banner-private-order/create`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

export const getWholesaleBannerList = (params, cb, errorCb) => {
	const url = `${endpoint}/banner-private-order/list`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

export const updateWholesaleBanner = (id, params, cb, errorCb) => {
	const url = `${endpoint}/banner-private-order/${id}/edit`;
	client
		.put(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Get Wallet Draft List
export const getWalletDraft = (params, cb, errorCb) => {
	const url = `${endpoint}/wallet-draft`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Process Wallet Draft
export const processWalletDraft = (params, cb, errorCb) => {
	const url = `${endpoint}/wallet-draft/process`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};
